"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toggle = void 0;
const react_1 = __importDefault(require("react"));
const ButtonGroup_1 = require("./ButtonGroup");
const ui_library_1 = require("@hum/ui-library");
const clsx_1 = __importDefault(require("clsx"));
const Toggle = ({ options, value, onValueChange }) => {
    return (react_1.default.createElement(ButtonGroup_1.Container, null, options.map(({ label, value: itemValue }) => {
        const onClick = () => {
            onValueChange(itemValue);
        };
        return (react_1.default.createElement(ui_library_1.Button, { key: label, onClick: onClick, size: ui_library_1.ButtonSize.SLIM, className: (0, clsx_1.default)({
                'bg-cta-quiet-hover': itemValue === value,
                'bg-cta-quiet-default hover:bg-cta-quiet-hover': itemValue !== value,
            }) }, itemValue));
    })));
};
exports.Toggle = Toggle;
//# sourceMappingURL=Toggle.js.map